export const heroStats = [
  { label: '日更瓜料', value: '200+' },
  { label: '收录站点', value: '500+' },
  { label: '吃瓜群众', value: '80万+' },
];

export const cardItems = [
  {
    id: 'card-1',
    title: '某顶流男星深夜密会神秘女子，疑似新恋情曝光',
    summary: '据知情人士透露，该男星与女方已交往数月，两人多次被拍到同框但始终未公开回应。',
    tag: '娱乐圈',
    hot: true,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20two%20celebrities%20meeting%20at%20night%20in%20a%20luxury%20restaurant%2C%20warm%20ambient%20lighting%2C%20artistic%20magazine%20editorial%20style%2C%20soft%20cinematic%20tones%2C%20dark%20background%20with%20spotlight%20effect%2C%20elegant%20composition&width=800&height=500&seq=gossip-card-01&orientation=landscape',
  },
  {
    id: 'card-2',
    title: '热门综艺录制现场突发意外，节目组紧急发文回应',
    summary: '录制过程中舞台设备出现故障，所幸无人受伤，节目组已暂停录制并进行全面安全检查。',
    tag: '综艺',
    hot: true,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20set%20with%20dramatic%20spotlights%20and%20silhouettes%2C%20TV%20show%20production%20atmosphere%2C%20warm%20orange%20and%20gold%20lighting%2C%20cinematic%20composition%2C%20theatrical%20mood%2C%20soft%20gradients&width=800&height=500&seq=gossip-card-02&orientation=landscape',
  },
  {
    id: 'card-3',
    title: '知名网红直播带货翻车，品牌方连夜发声明解约',
    summary: '该网红在直播中言论引发巨大争议，多个合作品牌迅速与其切割，粉丝量一夜暴跌。',
    tag: '网红',
    hot: false,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20live%20streaming%20studio%20setup%20with%20ring%20light%20and%20products%20on%20display%2C%20dramatic%20red%20and%20dark%20contrast%2C%20modern%20digital%20aesthetic%2C%20editorial%20photography%20style%2C%20moody%20atmosphere&width=800&height=500&seq=gossip-card-03&orientation=landscape',
  },
  {
    id: 'card-4',
    title: '年度大瓜：某影视公司内部邮件泄露，涉及多名艺人',
    summary: '邮件内容包含多位一线艺人合约细节与片酬信息，行业内部人士称真实性极高。',
    tag: '爆料',
    hot: true,
    image: 'https://readdy.ai/api/search-image?query=Confidential%20documents%20scattered%20on%20a%20dark%20desk%20with%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20warm%20amber%20accents%2C%20cinematic%20composition%2C%20high%20contrast%20shadows&width=800&height=500&seq=gossip-card-04&orientation=landscape',
  },
  {
    id: 'card-5',
    title: '某女星社交平台发文暗示离婚，粉丝涌入评论区安慰',
    summary: '该女星深夜发布一段意味深长的文字，随后秒删，但已被网友截图疯传引发热议。',
    tag: '娱乐圈',
    hot: false,
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20glowing%20in%20the%20dark%20showing%20social%20media%20interface%2C%20dramatic%20mood%20lighting%2C%20lonely%20atmosphere%2C%20warm%20screen%20glow%20against%20deep%20shadows%2C%20cinematic%20photography%20style&width=800&height=500&seq=gossip-card-05&orientation=landscape',
  },
  {
    id: 'card-6',
    title: '选秀节目黑幕再曝：选手自述被节目组强制要求签约',
    summary: '多位已淘汰选手联合发声，揭露选秀节目背后的不平等合约与暗箱操作内幕。',
    tag: '爆料',
    hot: true,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20with%20multiple%20spotlights%20forming%20dramatic%20patterns%2C%20silhouettes%20of%20performers%2C%20competition%20atmosphere%2C%20golden%20and%20warm%20tones%2C%20theatrical%20composition%2C%20high%20drama&width=800&height=500&seq=gossip-card-06&orientation=landscape',
  },
  {
    id: 'card-7',
    title: '短视频平台两大头部博主互撕，聊天记录完整曝光',
    summary: '双方各执一词，粉丝阵营分裂严重，该事件连续三天霸占各平台热搜榜首。',
    tag: '网红',
    hot: true,
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20composition%20showing%20digital%20conflict%2C%20warm%20versus%20cool%20color%20contrast%2C%20social%20media%20war%20visual%20metaphor%2C%20dramatic%20lighting%2C%20modern%20digital%20art%20style%2C%20bold%20graphic%20elements&width=800&height=500&seq=gossip-card-07&orientation=landscape',
  },
];

export const mediaItems = [
  {
    id: 'media-1',
    title: '独家专访：业内人士揭秘娱乐圈资本局中局',
    duration: '15:28',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interview%20setting%20with%20silhouetted%20figure%20against%20warm%20studio%20lighting%2C%20documentary%20style%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20soft%20golden%20backlight&width=800&height=450&seq=gossip-media-01&orientation=landscape',
  },
  {
    id: 'media-2',
    title: '深度解析：从饭圈文化看当代年轻人的追星心理',
    duration: '22:10',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=Crowd%20of%20fans%20with%20glowing%20light%20sticks%20at%20concert%2C%20artistic%20motion%20blur%2C%20warm%20golden%20and%20pink%20tones%2C%20dreamy%20atmosphere%2C%20editorial%20photography%20style%2C%20emotional%20crowd%20scene&width=800&height=450&seq=gossip-media-02&orientation=landscape',
  },
  {
    id: 'media-3',
    title: '直播回放：某顶流塌房事件全程时间线梳理',
    duration: '35:42',
    views: '256万',
    image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20studio%20with%20dramatic%20red%20lighting%2C%20timeline%20graphics%20on%20screens%2C%20tense%20atmosphere%2C%20broadcast%20journalism%20style%2C%20warm%20and%20dark%20contrast%2C%20cinematic%20composition&width=800&height=450&seq=gossip-media-03&orientation=landscape',
  },
  {
    id: 'media-4',
    title: '吃瓜指南：手把手教你辨别真假爆料信息',
    duration: '18:55',
    views: '73万',
    image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20digital%20documents%20and%20screens%2C%20investigative%20aesthetic%2C%20warm%20desk%20lamp%20lighting%2C%20mystery%20atmosphere%2C%20detective%20style%20composition%2C%20soft%20shadows&width=800&height=450&seq=gossip-media-04&orientation=landscape',
  },
];

export const topicItems = [
  { id: 'topic-1', name: '顶流塌房', heat: '986万', trend: 'up' as const },
  { id: 'topic-2', name: '明星恋情', heat: '754万', trend: 'up' as const },
  { id: 'topic-3', name: '综艺翻车', heat: '632万', trend: 'hot' as const },
  { id: 'topic-4', name: '网红互撕', heat: '521万', trend: 'up' as const },
  { id: 'topic-5', name: '选秀内幕', heat: '488万', trend: 'down' as const },
  { id: 'topic-6', name: '品牌解约', heat: '415万', trend: 'hot' as const },
  { id: 'topic-7', name: '直播带货', heat: '392万', trend: 'up' as const },
  { id: 'topic-8', name: '饭圈大战', heat: '367万', trend: 'down' as const },
  { id: 'topic-9', name: '隐婚生子', heat: '298万', trend: 'hot' as const },
  { id: 'topic-10', name: '片酬曝光', heat: '254万', trend: 'up' as const },
  { id: 'topic-11', name: '代拍乱象', heat: '189万', trend: 'down' as const },
];

export const updateItems = [
  {
    id: 'update-1',
    time: '10分钟前',
    title: '某男团成员被拍到深夜出入酒吧，经纪公司暂未回应',
    tag: '最新',
  },
  {
    id: 'update-2',
    time: '28分钟前',
    title: '热播剧女主疑似与导演不和，社交平台已互相取关',
    tag: '热议',
  },
  {
    id: 'update-3',
    time: '1小时前',
    title: '狗仔预告明日将曝"2026年最大瓜"，网友纷纷猜测主角',
    tag: '预告',
  },
  {
    id: 'update-4',
    time: '2小时前',
    title: '某综艺节目录制中三位嘉宾当场翻脸，导演紧急叫停',
    tag: '突发',
  },
  {
    id: 'update-5',
    time: '3小时前',
    title: '知名编剧发文暗讽某流量明星演技，粉丝涌入评论区',
    tag: '热议',
  },
  {
    id: 'update-6',
    time: '5小时前',
    title: '某品牌官宣新代言人后遭网友抵制，评论区彻底沦陷',
    tag: '翻车',
  },
  {
    id: 'update-7',
    time: '6小时前',
    title: '娱乐圈知名经纪人被曝税务问题，名下公司已列入异常',
    tag: '爆料',
  },
  {
    id: 'update-8',
    time: '8小时前',
    title: '某女星素颜街拍引发热议，网友评论两极分化严重',
    tag: '热议',
  },
  {
    id: 'update-9',
    time: '10小时前',
    title: '音乐节主办方临时更换压轴嘉宾，购票用户要求退款',
    tag: '维权',
  },
];

export const indexItems = [
  { id: 'idx-1', title: '娱乐圈八卦', desc: '明星恋情、婚姻、家庭等私生活爆料合集', count: '1.2万篇', icon: 'ri-star-line' },
  { id: 'idx-2', title: '网红爆料', desc: '头部网红、主播圈内幕与争议事件汇总', count: '8,563篇', icon: 'ri-live-line' },
  { id: 'idx-3', title: '综艺吃瓜', desc: '热门综艺节目幕后故事与录制花絮', count: '6,921篇', icon: 'ri-tv-line' },
  { id: 'idx-4', title: '影视动态', desc: '电影电视剧选角、片酬、拍摄进度追踪', count: '5,438篇', icon: 'ri-film-line' },
  { id: 'idx-5', title: '品牌翻车', desc: '明星代言翻车、品牌危机公关事件记录', count: '4,782篇', icon: 'ri-alert-line' },
  { id: 'idx-6', title: '饭圈观察', desc: '粉丝文化、应援活动与饭圈冲突深度分析', count: '4,156篇', icon: 'ri-heart-line' },
  { id: 'idx-7', title: '选秀档案', desc: '历年选秀节目选手动态与发展轨迹回顾', count: '3,509篇', icon: 'ri-mic-line' },
  { id: 'idx-8', title: '行业深扒', desc: '娱乐产业链条利益关系与运作模式揭秘', count: '2,847篇', icon: 'ri-search-eye-line' },
];

export const commentItems = [
  {
    id: 'comment-1',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20female%20avatar%20with%20pink%20hair%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '5分钟前',
    content: '这个瓜我吃了三天了，越吃越有意思！每天刷新都有新进展，比追剧还刺激，根本停不下来！',
    likes: '2.3万',
  },
  {
    id: 'comment-2',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20male%20avatar%20with%20cool%20expression%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '理性吃瓜人',
    time: '18分钟前',
    content: '建议大家理性看待，不要盲目站队。目前双方都没有实锤证据，让子弹再飞一会儿。不过这个站汇总信息确实方便。',
    likes: '1.8万',
  },
  {
    id: 'comment-3',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20female%20avatar%20with%20glasses%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '瓜田里的猹',
    time: '32分钟前',
    content: '终于找到一个能把各种瓜整合在一起的地方了！之前都是各个平台来回切换，现在一页搞定，对吃瓜人太友好了。',
    likes: '9,876',
  },
];

export const rankingItems = [
  { rank: 1, title: '年度顶流塌房事件全记录：从神坛到谷底只用72小时', heat: '🔥 1,286万', tag: '爆' },
  { rank: 2, title: '某影视公司内部邮件泄密：多位艺人片酬惊人数字曝光', heat: '989万', tag: '热' },
  { rank: 3, title: '知名网红直播翻车后续：五个品牌连夜解约索赔', heat: '872万', tag: '热' },
  { rank: 4, title: '综艺节目黑幕大起底：选手自述被迫签不平等合约', heat: '765万', tag: '热' },
  { rank: 5, title: '两大头部博主世纪互撕：完整聊天记录全网疯传', heat: '698万', tag: '新' },
  { rank: 6, title: '某女星深夜发文暗示婚变：夫妻已分居超半年', heat: '543万', tag: '新' },
  { rank: 7, title: '狗仔预告明日"超级大瓜"：网友列嫌疑人名单猜测', heat: '487万', tag: '新' },
];

export const carouselItems = [
  {
    id: 'carousel-1',
    title: '2026上半年娱乐圈大事件回顾',
    desc: '从年初到现在的重磅八卦一网打尽，吃瓜人必读的半年总结',
    tag: '专题',
    image: 'https://readdy.ai/api/search-image?query=Collage%20of%20newspaper%20headlines%20and%20magazine%20covers%20about%20entertainment%20news%2C%20warm%20retro%20tones%2C%20artistic%20layout%2C%20editorial%20design%20style%2C%20soft%20vignette%2C%20nostalgic%20press%20room%20aesthetic&width=1200&height=600&seq=gossip-carousel-01&orientation=landscape',
  },
  {
    id: 'carousel-2',
    title: '饭圈文化深度观察：追星的边界在哪里',
    desc: '从心理学和社会学角度剖析当代饭圈现象的本质与影响',
    tag: '深度',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20crowd%20of%20people%20holding%20glowing%20heart%20shapes%2C%20warm%20pink%20and%20coral%20gradient%2C%20dreamy%20soft%20focus%2C%20community%20concept%2C%20artistic%20photography%20style%2C%20emotional%20atmosphere&width=1200&height=600&seq=gossip-carousel-02&orientation=landscape',
  },
  {
    id: 'carousel-3',
    title: '娱乐圈资本博弈：谁在幕后操控流量',
    desc: '揭秘娱乐产业的资本运作模式和流量背后的商业逻辑',
    tag: '揭秘',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20chess%20board%20with%20golden%20pieces%20representing%20power%20and%20strategy%2C%20dramatic%20lighting%20from%20above%2C%20dark%20luxurious%20background%2C%20corporate%20power%20metaphor%2C%20warm%20gold%20and%20shadow%20contrast&width=1200&height=600&seq=gossip-carousel-03&orientation=landscape',
  },
  {
    id: 'carousel-4',
    title: '从素人到顶流：网红产业链全解析',
    desc: 'MCN机构、平台算法、流量变现——网红经济的完整图景',
    tag: '分析',
    image: 'https://readdy.ai/api/search-image?query=Digital%20network%20visualization%20with%20connected%20nodes%20and%20glowing%20lines%2C%20warm%20orange%20and%20amber%20tones%2C%20futuristic%20abstract%2C%20technology%20and%20media%20concept%2C%20clean%20modern%20aesthetic&width=1200&height=600&seq=gossip-carousel-04&orientation=landscape',
  },
  {
    id: 'carousel-5',
    title: '选秀十年：那些曾经爆红的选手现在怎样了',
    desc: '追踪历届选秀节目热门选手的职业发展与人生轨迹变化',
    tag: '回顾',
    image: 'https://readdy.ai/api/search-image?query=Timeline%20visualization%20with%20glowing%20milestones%20along%20a%20path%2C%20warm%20golden%20light%20trails%2C%20journey%20concept%2C%20abstract%20minimalist%20style%2C%20inspirational%20atmosphere%2C%20soft%20gradients&width=1200&height=600&seq=gossip-carousel-05&orientation=landscape',
  },
  {
    id: 'carousel-6',
    title: '吃瓜防坑指南：如何辨别真假娱乐新闻',
    desc: '资深媒体人分享辨别网络爆料真伪的实用技巧与经验',
    tag: '指南',
    image: 'https://readdy.ai/api/search-image?query=Detective%20desk%20with%20magnifying%20glass%20over%20scattered%20photos%20and%20notes%2C%20warm%20lamp%20light%2C%20investigation%20theme%2C%20mystery%20atmosphere%2C%20film%20noir%20style%2C%20classic%20detective%20aesthetic&width=1200&height=600&seq=gossip-carousel-06&orientation=landscape',
  },
];

export const featureItems = [
  {
    id: 'feat-1',
    icon: 'ri-flashlight-line',
    title: '实时瓜料追踪',
    desc: '7×24小时不间断更新最新八卦爆料，第一时间掌握娱乐圈风吹草动，永远比朋友圈快一步。',
  },
  {
    id: 'feat-2',
    icon: 'ri-stack-line',
    title: '多源瓜料聚合',
    desc: '整合微博、豆瓣、贴吧、小红书等主流社交平台的吃瓜资源，一站浏览全网红热议内容。',
  },
  {
    id: 'feat-3',
    icon: 'ri-compass-3-line',
    title: '智能吃瓜导航',
    desc: '根据你的吃瓜偏好智能推荐相关站点和话题，帮你快速找到最感兴趣的内容入口。',
  },
  {
    id: 'feat-4',
    icon: 'ri-shield-check-line',
    title: '爆料真实性标注',
    desc: '对每一条瓜料标注可信度等级，区分实锤、传闻与谣言，让你吃瓜不翻车。',
  },
  {
    id: 'feat-5',
    icon: 'ri-group-line',
    title: '吃瓜社区互动',
    desc: '加入最活跃的吃瓜社区，与百万吃瓜群众一起讨论最新八卦，分享独家瓜料线索。',
  },
];

export const faqItems = [
  {
    id: 'faq-1',
    question: '爆料吃瓜是什么类型的网站？',
    answer: '爆料吃瓜是一个专业的吃瓜网站与爆料网站导航聚合平台，致力于为吃瓜群众提供一站式在线吃瓜导航服务。我们实时聚合微博、豆瓣、贴吧、小红书等全网的娱乐圈热门八卦和实时瓜料，涵盖明星恋情、综艺内幕、网红翻车、选秀黑幕等各类吃瓜资源，让你不再错过任何一个热点事件。',
  },
  {
    id: 'faq-2',
    question: '网站上的瓜料来源可靠吗？如何判断真假？',
    answer: '我们的瓜料来自多个渠道的交叉验证，并为每一条信息标注可信度等级。建议用户在吃瓜时保持理性，对于标注为"传闻"和"待证实"的内容，等待官方或更多实锤信息出现后再做判断。我们始终倡导理性吃瓜、文明讨论的社区氛围。',
  },
  {
    id: 'faq-3',
    question: '如何向我投稿或提供吃瓜线索？',
    answer: '欢迎通过页面上的"我要爆料"入口提交你掌握的独家瓜料线索。投稿时可选择匿名或署名，我们会对投稿人信息严格保密。特别重大的独家爆料经核实后，我们会标注为"独家"并进行重点推荐展示。',
  },
  {
    id: 'faq-4',
    question: '网站更新频率如何？会不会错过重要瓜料？',
    answer: '我们保持7×24小时不间断更新，运营团队全天候监控各大社交平台和娱乐资讯渠道，确保热门八卦和实时瓜料在第一时间被收录。首页快讯区每10-30分钟就会有新内容刷新，吃瓜榜单和话题热度每小时自动更新一次。建议收藏本站或关注我们的移动端入口，随时随地畅快吃瓜。',
  },
];